<template>
    <section id="events"  v-if="data != null">
        <div class="container-fluid">
            <div class="row">
                <div class="top-bg"></div>
                <div class="col-4 top-layer" id="info">
                    <div><router-link to="/#home"><img src="/img/balerija-top-logo.png" width="50%" style="margin-top: 1vh;padding-left: 15px;padding-right: 15px;padding-top: 15px;opacity: 0.8;"></router-link></div>
                    <router-link to="/#stage" class="back"><span aria-hidden="true" data-icon="," ></span></router-link>
                    <div id="event_info">
                        <div id="date">{{ formatDate(data.datums) }}</div>
                        <div id="title">{{ data.nosaukums }}</div>
                        <div class="desc" v-html="data.apraksts" :class="{ 'expand' : desc  == true}">{{ data.apraksts }}</div>
                        <div class="more-button">
                            <span aria-hidden="true" data-icon="6" @click="expandDesc()" v-if="!desc"></span>
                            <span aria-hidden="true" data-icon="4" @click="expandDesc()" v-if="desc"></span>
                        </div>
                        <div id="social" v-if="data != null">
                            <a :href="data.website" class="social" v-if="data.website != null"><i class="fas fa-globe"></i>{{ data.website }}</a>
                            <a :href="'https://www.facebook.com/'+data.facebook" class="social" v-if="data.facebook != null"><i class="fab fa-facebook-square"></i>{{ data.facebook }}</a>
                            <a :href="'https://www.instagram.com/'+data.instagram" class="social" v-if="data.instagram"><i class="fab fa-instagram"></i>{{ data.instagram }}</a>
                        </div>
                    </div>
                    <div id="demos">
                        <embed width="45%" height="100%" :src="'https://www.youtube.com/embed/'+d" v-for="(d, i) in data.demos" :key="i+d">
                    </div>

                    <div id="ticket">
                    <div>Koncerta sākums 21:00</div>
                    <div>Ieeja 3-5eur ticketshop.lv</div>

                    <div id="ticket_button"><a href="#promo" id="promo_a">TICKETSHOP</a></div>

                    <div id="warning"><i class="fas fa-exclamation-triangle"></i> Koncerta laikā filmē un fotogrāfē, pretenziju gadījumā vērsties pie rīkotāja.</div>
                    </div>
                </div>
            
                <div class="col-4 text-center top-layer">
                    <div class="section_title" id="center">
                        SKATUVE
                        <div class="title_nav">
                            <a href="#" class="pasakumi active"><div class="dot"></div><div class="title">PASĀKUMI</div></a>
                            <a href="/gallery" class="galerija"><div class="dot"></div><div class="title">GALERIJA</div></a>
                            <a href="/groups" class="grupam"><div class="dot"></div><div class="title">GRUPĀM</div></a>
                        </div>
                        <div id="banner">
                            <hooper ref="carousel" :vertical="true" :itemsToShow="1" @afterSlide="afterSlide" @slide="updateCarousel" style="height: 100%;max-width: 65%;background: transparent;margin-left: auto;margin-right: auto;">
                                <slide class="slide-item" v-for="(e, index) in events" :key="index">
                                    <img :src="'/img/banners/'+e.id+'.jpg'" style="object-fit: contain;">
                                </slide>
                            </hooper>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="top-date">
                        <div class="text">2020</div>
                    </div>
                    <div class="list">
                        <div class="m"  v-for="(d, i) in months" :key="i">
                            <div class="month">{{ monthNames[getMonthNum(d)] }}</div>
                            <table class="table table-hover table-borderless">
                            <tbody>     
                                <router-link style="line-height: 1vh;" v-on:click.native="loadEvent(g.id, gIndex)" :to="`/events/${g.id}`" tag="tr" v-for="(g, gIndex) in events" v-if="getMonthNum(g.datums) == getMonthNum(d) && getYear(g.datums) == getYear(d)" :class="{'active' : g.id == id}" :key="gIndex" :id="g.id">
                                    <td style="width: 10%;">{{ formatDate(g.datums) }}</td>
                                    <td style="width: 70%;display: inline-block;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;" class="title">{{ g.nosaukums }}</td>
                                    <td style="width: 30%; display: inline-block;" class="genre">heavy metal</td>
                                    <td style="width: 10%;">{{ g.cena }}e</td>
                                </router-link>
                            </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { Hooper, Slide } from 'hooper';
import 'hooper/dist/hooper.css';

export default {
    components: {
        Hooper,
        Slide
    },
    data()
    {
        return {
            data: null,
            selected: 0,
            mobile: null,
            id: null,
            eventIndex: 0,
            events: null,
            desc: false,
            months: [],
            monthNames: ["Janvāris", "Februāris", "Marts", "Aprīlis", "Maijs", "Jūnijs",
            "Jūlijs", "Augusts", "Septembris", "Oktobris", "Novembris", "Decembris"]
        }
    },
    beforeMount()
    {
        this.id = this.$route.params.id;

        this.loadEvent(this.id, 0);

        this.$http({
            url: `/events`,
            method: 'GET',
        })
        .then((res) => {
            this.events = res.data;

            this.events.forEach((element, i) => {
                if(this.checkMonthAndYear(element.datums))
                {
                    this.months.push(element.datums);
                }
                
                if(element.id == this.id)
                    this.eventIndex = i;
            });
            console.log(res.data);
        }, () => {
            this.has_error = true
        })
    
    },
    mounted()
    {
        this.$nextTick(function () {
            setTimeout(() => {
                var element = document.getElementById(this.id);
                console.log(this.id);
                element.scrollIntoView({ block: 'start',  behavior: 'smooth', inline: 'start' });
            }, 500);
        });
    },
    watch: {
        eventIndex () {
            setTimeout(() => {
                this.$refs.carousel.slideTo(this.eventIndex);
            }, 500);
        }
    },
    methods: {
        afterSlide: function()
        {
            this.loadEvent(this.events[this.eventIndex].id, this.eventIndex);
        },
        updateCarousel: function(payload)
        {
            this.eventIndex = payload.currentSlide;
            this.loadEvent(this.events[this.eventIndex].id, this.eventIndex);
        },
        expandDesc: function()
        {
            this.desc = !this.desc;
        },
        selectMenuItem: function(index)
        {
            this.selected = index;
        },
        isMobile: function()
        {
            if(window.innerWidth < 1280)
                this.mobile = true;
            else
                this.mobile = false;
        },
        checkMonthAndYear: function(date)
        {
            date = new Date(date);
            
            if(date.getMonth() != this.prevMonth || date.getFullYear() != this.prevYear)
            {
                this.prevMonth = date.getMonth();
                this.prevYear = date.getFullYear();
                return true;
            }

            return false;
        },
        getMonthNum: function(date)
        {
            date = new Date(date);

            return date.getMonth();
        },
        getYear: function(date)
        {
            date = new Date(date);

            return date.getFullYear();
        },
        scrollToElement: function() {
            var element = document.getElementById(this.id);
            element.scrollIntoView({ block: 'start',  behavior: 'smooth', inline: 'start' });
        },
        loadEvent: function(id, index) {

            this.id = id;
            this.eventIndex = index;
            this.$http({
                url: `/events/${id}`,
                method: 'GET',
            })
            .then((res) => {
                this.data = res.data;
                this.data.demos = JSON.parse(this.data.demos);
                console.log(this.data);
            }, () => {
                this.has_error = true
            })
        },
        formatDate: function(date)
        {
            date = new Date(date);

            var day = (date.getDate() < 10 ? '0' : '') + date.getDate();
            var month = ((date.getMonth()+1 < 10) ? '0' : '') + (date.getMonth()+1);

            return `${day}.${month}.`;
        }
    }
}
</script>